module.exports = __webpack_public_path__ + "static/img/training_system_s3_max.6c113287.png";